import React from "react";
import { ShortCompareGraphBars } from "./types";

interface Props {
  bars: ShortCompareGraphBars;
}

export default function ShortCompareGraph({ bars }: Props) {
  const barComponents = bars.map((bar, idx) => {
    return "value" in bar ? (
      <div
        key={idx}
        className={`short-graph-bar ${bar.dull ? "your" : "my"}-score`}
      >
        <span
          style={{
            width: `${bar.value}%`,
          }}
          className="bar"
        />
        <span className="ms-2">{bar.label}</span>
        <span className="fw-bold">{bar.value}</span>
      </div>
    ) : (
      bar
    );
  });

  return <div className="short-graph">{barComponents}</div>;
}
